module.exports = __webpack_public_path__ + "media/site_templates/www.pianomovingservice.com.au/images/our_services_2-0790f2b53c50b32a0641e75360a08764.jpg";